/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";

const WebProjectPresention = ({
  img,
  projectTitle,
  projectDescription,
  languages,
  frameworks,
}) => {
  return (
    <div data-aos="fade-right" className="project_div">
      <div className="project_img">
        <img src={img} alt="Project Image" />
      </div>
      <div className="porjectInfo_div">
        <h1>{projectTitle}</h1>
        <p className="description_span">{projectDescription}</p>
        <div className="projectDetails">
          <p>Languages and Libraries: {languages}</p>
          <p>Frameworks: {frameworks} </p>
        </div>
      </div>
    </div>
  );
};

export default WebProjectPresention;
